import { Platform, View } from 'react-native';
import React, { createContext, useContext, useState } from 'react';

import { Classes } from '@providers/Theme/types';
import { PaddinSpacingArgs } from '@providers/Theme/utils/makePaddingMixin';
import { makeStyles } from '@providers/Theme';
import { Direction, useDirection } from '@providers/Direction';

import { initRootWidth } from './constants';

type GridContainerStyleProps = {
  direction: Direction;
  rootWidth: number;
  spacing: number;
  padding: PaddinSpacingArgs;
  classes?: Classes<'root'>;
};

const useStyles = makeStyles<GridContainerStyleProps>((theme) => ({
  root: (props) => {
    return {
      ...theme.mixins.padding(...props.padding),
      ...props.classes?.root,

      backgroundColor: 'white',
    };
  },
  content: (props) => {
    const { paddingRight, paddingLeft } = theme.mixins.padding(
      ...props.padding,
    );
    const horizontalPadding =
      (typeof paddingRight === 'number' ? paddingRight : 0) +
      (typeof paddingLeft === 'number' ? paddingLeft : 0);

    // console.log({ horizontalPadding });
    return {
      width:
        theme.spacingUnit * props.spacing + props.rootWidth - horizontalPadding,
      display: 'flex',
      justifyContent: 'flex-start',
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginLeft: theme.spacing(
        Platform.OS === 'web'
          ? props.spacing * -1
          : props.direction === 'rtl'
          ? props.spacing * 0
          : props.spacing * -1,
        // Platform.OS === 'web' ? props.spacing * -1 : -1,
        // props.spacing * -1,
      ),
      marginTop: theme.spacing(props.spacing * -1),
    };
  },
}));

type GridContainerProps = Partial<GridContainerStyleProps> & {
  children: React.ReactNode;
  testID?: string;
};

const GridSpacingContext = createContext(0);
export const useGridSpacing = () => useContext(GridSpacingContext);

export const GridContainer: React.FC<GridContainerProps> = ({
  children,
  testID,
  ...gridStyleProps
}) => {
  const spacing = gridStyleProps.spacing ?? 0;
  const padding = gridStyleProps.padding ?? [0];

  const [rootWidth, setRootWidth] = useState<number | null>(initRootWidth);
  const { direction } = useDirection();
  const styles = useStyles({
    rootWidth: rootWidth ?? 0,
    spacing,
    padding,
    direction,
    classes: gridStyleProps.classes,
  });

  return (
    <GridSpacingContext.Provider value={spacing}>
      <View
        testID={testID}
        style={styles.root}
        onLayout={(e) => {
          setRootWidth(e.nativeEvent.layout.width);
        }}>
        {rootWidth && <View style={styles.content}>{children}</View>}
      </View>
    </GridSpacingContext.Provider>
  );
};
